import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import cx from 'classnames'
import { CheckSuccessIcon } from '../app-icon/Icons'

const styles = theme => ({
  icon: {
    position: 'relative',
    width: 29,
    height: 29,
    border: 'solid 1px rgba(136, 102, 255, 0.2)',
    borderRadius: '100%',
  },
  icon_active: {
    border: 'solid 1px #ffcc00',
  },
  icon_pointer_active: {
    display: 'block',
    width: 6,
    height: 6,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#000000',
    borderRadius: '100%',
  },
  icon_completed: {
    border: 'solid 1px #8866ff',
  },
  icon_pointer: {
    position: 'absolute',
    display: 'block',
    width: 6,
    height: 6,
    top: '50%',
    left: '50%',
    borderRadius: '100%',
    transform: 'translate(-50%, -50%)',
    border: 'solid 1px rgba(136, 102, 255, 0.2)',
  },
  checkIcon: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
})

function IconStep(props) {
  const { completed, active, classes } = props

  if (completed) {
    return (
      <span className={cx(classes.icon, classes.icon_completed)}>
        <CheckSuccessIcon className={classes.checkIcon} />
      </span>
    )
  }

  if (active) {
    return (
      <span className={cx(classes.icon, classes.icon_active)}>
        <span className={cx(classes.icon_pointer_active)} />
      </span>
    )
  }

  return (
    <span className={cx(classes.icon)}>
      <span className={cx(classes.icon_pointer)} />
    </span>
  )
}

export default withStyles(styles)(IconStep)
